import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Button, 
  // Grid, 
  // Card, 
  // CardContent,
  Stack,
  Alert
} from '@mui/material';
// TODO: Restore when features section is re-enabled
// import { 
//   CheckBox, 
//   LocationOn, 
//   Notifications, 
//   Security 
// } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import apiService from '../services/apiService';

const HomePage = () => {
  const { isAuthenticated } = useAuth();
  const [registrationStatus, setRegistrationStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRegistrationStatus = async () => {
      try {
        await apiService.loadConfiguration();
        const status = await apiService.getRegistrationStatus();
        setRegistrationStatus(status);
      } catch (error) {
        console.warn('Failed to fetch registration status:', error);
        // Default to closed beta if we can't determine status
        setRegistrationStatus({ registration_open: false, closed_beta: true });
      } finally {
        setLoading(false);
      }
    };

    if (!isAuthenticated) {
      fetchRegistrationStatus();
    } else {
      setLoading(false);
    }
  }, [isAuthenticated]);

  // TODO: Restore when features are implemented
  // const features = [
  //   {
  //     icon: <CheckBox color="primary" sx={{ fontSize: 40 }} />,
  //     title: 'Smart Todo Management',
  //     description: 'Create, organize, and track your tasks with intelligent features that adapt to your workflow.'
  //   },
  //   {
  //     icon: <LocationOn color="primary" sx={{ fontSize: 40 }} />,
  //     title: 'Location-Aware',
  //     description: 'Get contextual reminders based on your location. Never forget tasks when you\'re in the right place.'
  //   },
  //   {
  //     icon: <Notifications color="primary" sx={{ fontSize: 40 }} />,
  //     title: 'Smart Notifications',
  //     description: 'Receive timely reminders and notifications to stay on top of your important tasks.'
  //   },
  //   {
  //     icon: <Security color="primary" sx={{ fontSize: 40 }} />,
  //     title: 'Secure & Private',
  //     description: 'Your data is encrypted and secure. We respect your privacy and keep your information safe.'
  //   }
  // ];

  return (
    <Container maxWidth="lg">
      {/* Hero Section */}
      <Box sx={{ textAlign: 'center', py: { xs: 6, md: 10 } }}>
        <Typography 
          variant="h2" 
          component="h1" 
          gutterBottom
          sx={{ 
            fontWeight: 700,
            fontSize: { xs: '2.5rem', md: '3.5rem' },
            background: 'linear-gradient(45deg, #1976d2, #42a5f5)',
            backgroundClip: 'text',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          checkboxr
        </Typography>
        
        <Typography 
          variant="h5" 
          color="text.secondary" 
          paragraph
          sx={{ maxWidth: 600, mx: 'auto', mb: 4 }}
        >
          The location-aware todo application that helps you stay organized 
          and get things done, wherever you are.
        </Typography>

        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          justifyContent="center"
          sx={{ mb: 4 }}
        >
          {isAuthenticated ? (
            <Button 
              variant="contained" 
              size="large" 
              component={Link} 
              to="/dashboard"
              sx={{ px: 4, py: 1.5 }}
            >
              Go to Dashboard
            </Button>
          ) : (
            <>
              {!loading && registrationStatus?.registration_open && (
                <Button 
                  variant="contained" 
                  size="large" 
                  component={Link} 
                  to="/register"
                  sx={{ px: 4, py: 1.5 }}
                >
                  Get Started
                </Button>
              )}
              <Button 
                variant={registrationStatus?.registration_open ? "outlined" : "contained"}
                size="large" 
                component={Link} 
                to="/login"
                sx={{ px: 4, py: 1.5 }}
              >
                Sign In
              </Button>
            </>
          )}
        </Stack>

        {/* Closed beta message */}
        {!isAuthenticated && !loading && registrationStatus?.closed_beta && (
          <Alert severity="info" sx={{ maxWidth: 600, mx: 'auto', mb: 4 }}>
            checkboxr is currently in closed beta. 
            Please sign in if you have an account, or contact an administrator for an invitation link.
          </Alert>
        )}
      </Box>

      {/* Features Section - TODO: Restore when features are implemented */}
      {/* <Box sx={{ py: { xs: 4, md: 8 } }}>
        <Typography 
          variant="h3" 
          component="h2" 
          textAlign="center" 
          gutterBottom
          sx={{ mb: 6 }}
        >
          Why Choose checkboxr?
        </Typography>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card 
                sx={{ 
                  height: '100%', 
                  textAlign: 'center',
                  transition: 'transform 0.2s',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: 4
                  }
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box sx={{ mb: 2 }}>
                    {feature.icon}
                  </Box>
                  <Typography variant="h6" component="h3" gutterBottom>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box> */}

      {/* CTA Section removed - content now focused on hero section */}
    </Container>
  );
};

export default HomePage;